import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { applyContainerQuery } from 'react-container-query';

import containerQuery from '../../constants/containerQuery';
import containerQueryProps from '../../props/containerQueryProps';
import parsePhone from '../../utils/parsePhone';
import EventShape from '../types/eventShape';
import VenueLocationSummary from '../VenueLocationSummary';
import UpcomingEventsContainer from '../../containers/UpcomingEventsContainer';
import VenueShape from '../types/venue';

import './EventDetailsBottom.scss';

const phoneNormalize = (phone) => {
  const parsed = parsePhone(phone);
  return {
    phoneLabel: parsed.nationalFormat,
    phoneUrl: parsed.e164,
  };
};

const locationNormalize = (location = {}) => {
  const {
    address_1: address1,
    address_2: address2,
    locality: city,
    postal_code: postalCode,
    region: state,
  } = location;

  return {
    address1,
    address2,
    city,
    postalCode,
    state,
  };
};

const EventDetailsBottom = ({
  $rootScope,
  Analytics,
  containerQuery: {
    md, lg, xl, xxl,
  },
  day,
  event,
  eventId,
  isMobile,
  sameDay,
  venue,
}) => {
  const {
    id: {
      resy: venueId,
    } = {},
    contact = {},
    location,
    name,
    social,
  } = venue;
  const phone = event?.phone || contact.phone_number;
  const { url } = contact;
  return (
    <div className="EventDetailsBottom">
      <div className={cx('EventDetailsBottom__container', {
        'EventDetailsBottom__container--lg': lg,
        'EventDetailsBottom__container--md': md,
        'EventDetailsBottom__container--xl': xl,
        'EventDetailsBottom__container--xxl': xxl,
      })}
      >
        <UpcomingEventsContainer
          $rootScope={$rootScope}
          className="EventDetailsBottom__UpcomingEventsContainer"
          day={day}
          eventId={eventId}
          isMobile={isMobile}
          sameDay={sameDay}
          venue={venue}
          venueId={venueId}
        />
        <div className="EventDetailsBottom__location-container">
          <VenueLocationSummary
            Analytics={Analytics}
            location={locationNormalize(location)}
            isMobile={isMobile}
            name={name}
            phone={phoneNormalize(phone)}
            social={social}
            url={url}
            venue={{ id: venueId }}
          />
        </div>
      </div>
    </div>
  );
};

EventDetailsBottom.propTypes = {
  $rootScope: PropTypes.shape({
    previewMode: PropTypes.bool,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  containerQuery: containerQueryProps,
  day: PropTypes.string,
  event: EventShape.isRequired,
  eventId: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
  sameDay: PropTypes.bool,
  venue: VenueShape.isRequired,
};

EventDetailsBottom.defaultProps = {
  containerQuery: {},
  day: undefined,
  isMobile: false,
  sameDay: undefined,
};

EventDetailsBottom.displayName = 'EventDetailsBottom';
export { EventDetailsBottom as Component };
export default applyContainerQuery(EventDetailsBottom, containerQuery);
